import React from 'react';
import {Paper, Container, Typography, Button, Divider} from '@material-ui/core';
import Alert from '@mui/material/Alert';
import {useHistory, useLocation} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    messagingGroupsAll: {
        textStyle: "Core / LG / page-title",
        fontFamily: "Chronicle Text G1 ",
        fontStyle: "semiBold",
        fontSize: "48px ",
        align: "left",
        verticalAlign: "top",
        letterSpacing: "0.5px",
        paddingTop: "61px"
    },
    divider: {
        fill: "solid",
        borderBottom: "6px solid #B40F87",
        marginBottom: "16px !important",
        marginTop: "10px !important",
        content: '""',
        position: "absolute",
        left: 0,
        bottom: 0,
        width: 40,
    },
    content: {
        color: "#6D6D6E ",
        fontSize: "32px ",
        fontStyle: "semiBold ",
    },
    alertContent: {
        marginTop: '46px !important',
        backgroundColor: "white !important",
        borderLeft: '5px solid #DB6200',
        boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.07), 0px 3px 3px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.1);'
    },
    paper: {
        boxShadow: "0px 0px 0px 0px !important",
        // paddingTop: "46px !important",
        width: "272px",
        paddingTop: "42px",
        paddingBottom: "42px"
    },
    basicInfo: {
        fontFamily: "Whitney !important",
        fontWeight: "bold !important",
        fontSize: "16px !important",
        align: "left",
        verticalAlign: "top"
    },
    textField: {
        paddingTop: "6px !important",
    },
    lastName: {
        marginTop: "24px !important",
    },
    dob: {
        marginTop: "42px !important",
    },
    button: {
        marginTop: "42px !important",
    },
    textInfo: {
        fontFamily: "Whitney !important",
        fontSize: "16px !important",
        align: "left",
        verticalAlign: "top"
    },
    textButton: {
        paddingLeft: "0px !important",
        fontFamily: "Whitney !important",
        fontWeight: "bold !important",
        letterSpacing: "1.25px",
        fontSize: "1rem !important",
        marginTop: "24px !important",
        marginBottom: "48px !important",
    },
    alertSuccessContent: {
        marginTop: '46px !important',
        backgroundColor: "white !important",
        borderLeft: '5px solid #126E36',
        boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.07), 0px 3px 3px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.1);'
    },
    updateccInfo: {
        fontFamily: "Whitney !important",
        fontSize: "18px !important",
        align: "left",
        verticalAlign: "top",
        color: "rgba(0, 0, 0, 0.6)",
        marginTop: "32px",
        height: "32px"
    },
    cardButton: {
        color: "#1E69D2 !important",
        borderColor: "#1E69D2 !important",
        marginBottom: "32px !important"
    },
    buttonFilled: {
        color: "#FFFFFF !important",
        borderColor: "#1E69D2 !important",
        backgroundColor: "#1E69D2 !important"
    },
})
const CCExistsPage = ({}) => {
    const classes = useStyles();
    const history = useHistory();

    const claimReq = useLocation()
    return (
        <>
            <Container>
                <Typography style={{
                    fontSize: "48px", fontWeight: 400, padding: "1em 0 1rem", letterSpacing: "0.5px",
                    lineHeight: "55px",
                    fontFamily: '"Chronicle Text G1", "Frank Ruhl Libre", serif',
                    position: "relative",
                    marginBottom: "1em",
                }}>Ascension Rx Payment Details <Divider
                    style={{borderBottom: "6px solid #B40F87", width: 40}}/></Typography>

                <Typography style={{
                    color: "#6D6D6E ",
                    fontSize: "24px ",
                    fontStyle: "semiBold ",
                    margin: "35px, 0px",
                    fontFamily: "Whitney"
                }}>Hello {claimReq.state.firstName}, to make refills easy and hassle-free we need to your collect
                    payment details.</Typography>
                <Alert severity="success" className={classes.alertSuccessContent}>
                    <Typography>There is a card on file for this account.</Typography>
                    <Typography variant="caption">If you do not need to make any changes to your payment information,
                        you can safely close this window or tab.</Typography>
                </Alert>
                <Typography className={classes.updateccInfo}>Select “Update Payment Info” to change your payment
                    information.</Typography>
                <Paper className={classes.paper}>
                    <Button variant="outlined" className={classes.cardButton} onClick={() => {
                        history.push("/EnterCCDetailsPage/")
                    }}>UPDATE PAYMENT INFO</Button>

                </Paper>
            </Container>
        </>
    )
}

export default CCExistsPage;

